import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { VButton, VStack } from '@/package';
import { useOnboardingLayout } from '@/provider/layout';

const OffboardingPage = () => {
  const { setTitle } = useOnboardingLayout();
  const navigate = useNavigate();

  useEffect(() => {
    setTitle('The workspace has been successfully deleted.');
  }, []);

  return (
    <>
      <VStack className="w-[608px] pt-6" items="center" gap={1.5}>
        <VStack gap={0.25} items="center">
          <div className="px-2 py-1 text-body-xl">
            Thank you for using VueX.
          </div>
          <ul className="px-2 py-1 text-body-lg text-gray-500">
            <li className="list-disc">Company or team name : company name</li>
            <li className="list-disc">
              Account recovery is available until : YYYY-MM-DD HH:MM:SS
            </li>
          </ul>
          <div className="px-2 py-1 text-center text-body-xl">
            If you wish to restore your account, please contact us at [
            <span className="text-blue-300">support@vueron.com</span>] We’ll be
            ready with an even better service if you decide to return.
          </div>
        </VStack>

        <VButton
          className="w-[296px]"
          outlined
          variant="secondary"
          onClick={() => navigate('/')}
        >
          VueX main
        </VButton>
      </VStack>
    </>
  );
};

export default OffboardingPage;
